


























































import { defineComponent, PropType, ref, onMounted, onUnmounted, watch } from '@nuxtjs/composition-api';
import { debounce } from 'lodash-es';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import { DynamicPartsEncloseText, DynamicPartsEncloseTextBlack } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppImage,
    AppRectButton,
  },
  props: {
    item: {
      type: Object as PropType<DynamicPartsEncloseText | DynamicPartsEncloseTextBlack>,
      required: true,
    },
    isBlack: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const wrapper = ref<HTMLDivElement>();
    const wineImage = ref<InstanceType<typeof AppImage>>();
    const isCenterPosition = ref(false);

    const changeImageHeight = debounce(() => {
      if (!wineImage.value || !wrapper.value) return;

      const r = wineImage.value.$el.clientHeight / 240;
      const w = (wineImage.value.$el.clientWidth * 1) / r;

      isCenterPosition.value = w / wrapper.value.clientWidth > 0.65;
    }, 100);

    watch([wrapper, wineImage], changeImageHeight);

    onMounted(() => {
      window.addEventListener('resize', changeImageHeight);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', changeImageHeight);
    });

    return { wrapper, wineImage, isCenterPosition };
  },
});
